export default __webpack_public_path__ + "media/images/logo-symbol-icon-9b91b9c89c5f345ec0e3041497e8060b.svg";